<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <div class="card-body">

            <div class="mb-2 text-right">
                <button v-b-modal.adjustment-modal class="btn btn-primary d-print-none" data-toggle="modal"><i
                        class="fa fa-plus"></i>Add Adjustment
                </button>
            </div>

            <BTable
                    :current-page="filterOptions.page"
                    :fields="tableFields"
                    :items="adjustments"
                    :per-page="filterOptions.pageSize"
                    :responsive="true"
                    primary-key="id"
                    show-empty
                    striped
                    table-class="table-align-middle">

                <template v-slot:cell(id)="row">
                    <button @click="onDelete(row.item.id)" class="btn btn-sm btn-danger" type="button">
                        <i class="fa fa-trash"></i> Delete
                    </button>
                </template>

                <template v-slot:cell(amount)="row">
                    {{row.item.amount | currency}}
                </template>

                <!-- Footer Pagination -->
                <template v-slot:custom-foot>
                    <b-tr>
                        <b-td :colspan="tableFields.length">
                            <AppTablePagination
                                    :page.sync="filterOptions.page"
                                    :pageSize.sync="filterOptions.pageSize"
                                    :totalCount.sync="totalAdjustments"
                            ></AppTablePagination>
                        </b-td>
                    </b-tr>
                </template>
            </BTable>
        </div>

        <!-- The modal popup containing employee payroll information -->
        <b-modal header-class="bg-maroon text-white" title="Add Adjustment" id="adjustment-modal">
            <form @submit.prevent="onSubmit()">

                <div class="container-fluid">
                    <div class="form-group row">
                        <div class="col-3 col-sm-12">
                            <label>Adjustment Name</label>
                        </div>
                        <div class="col-9 col-sm-12">
                            <input type="text" v-model="adjustmentName" placeholder="Adjustment Name"
                                   class="form-control">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-3 col-sm-12">
                            <label>Adjustment Amount</label>
                        </div>
                        <div class="col-9 col-sm-12">
                            <input v-model.number="adjustmentAmount" type="text" class="form-control"
                                   placeholder="Adjustment Amount">
                        </div>
                    </div>
                </div>
            </form>
            <template v-slot:modal-footer="{cancel}">
                <button :disabled="isSubmitting" class="btn btn-primary" type="submit" @click="onSubmit">Save</button>
                <button @click="cancel" class="btn btn-danger">Close</button>
            </template>

        </b-modal>

    </AppLoadingContainer>
</template>

<script>
    import AzureBillingService from "../../services/AzureBillingService";
    import {currency} from "../../filters/Currency";
    import AppLoadingContainer from "../shared/AppLoadingContainer";
    import AppTablePagination from "../shared/AppTablePagination";
    import {ToastType} from "@/services/models/shared/ToastType";

    export default {
        components: {
            AppLoadingContainer,
            AppTablePagination
        },
        filters: {
            currency
        },
        data() {
            return {
                adjustments: [],
                totalAdjustments: 0,
                isLoaded: false,
                filterOptions: {
                    page: 1,
                    pageSize: 10
                },
                adjustmentName: null,
                adjustmentAmount: 0,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: "width:125px"
                    },
                    {
                        key: 'name',
                        label: 'Name',
                    },
                    {
                        key: 'amount',
                        label: 'Amount',
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    }
                ]
            }
        },
        props: {
            billingPeriodId: {
                type: Number,
                required: true
            },
            subscriptionId: {
                type: String,
                required: true
            }
        },
        methods: {
            onDelete(id) {
                const vm = this;

                AzureBillingService.deleteSubscriptionAdjustment(id)
                    .then(() => {
                        vm.alert(ToastType.Success, "The adjustment was successfully deleted");
                    }).catch((error) => {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).then(() => {
                    this.loadData();
                });
            },

            onSubmit() {
                const vm = this;

                AzureBillingService.addSubscriptionAdjustment(this.billingPeriodId, this.subscriptionId, {
                    amount: this.adjustmentAmount,
                    name: this.adjustmentName
                }).then(() => {
                    this.alert(ToastType.Success, `Adjustment '${this.adjustmentName}' was successfully created`);
                    this.loadData();

                    this.adjustmentName = null;
                    this.adjustmentAmount = 0;
                }).catch((error) => {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).finally(() => this.$root.$emit('bv::hide::modal', 'adjustment-modal', '#btnShow'));
            },

            loadData() {
                const vm = this;
                AzureBillingService.getSubscriptionAdjustments(this.billingPeriodId, this.subscriptionId)
                    .then(function (response) {
                        vm.adjustments = response;
                        vm.totalAdjustments = response.length;
                    }).catch(() => {
                    vm.redirectToError();
                }).finally(() => vm.isLoaded = true);
            }
        },
        created() {
            this.loadData();
        }
    }
</script>
